module.exports = __webpack_public_path__ + "static/img/pic2@2x.4cfe4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liveimg/pic2@2x.png
// module id = xRQq
// module chunks = 1